import { Injectable } from '@angular/core';
import {getAllCategorias, getAllPromocionesMongoFront} from "../../../graphql/graphql.queris";
import {Apollo} from "apollo-angular";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class PromotionPersonService {

  constructor(
    private apollo: Apollo
  ) {
  }


    getAllPromociones(): Observable<any[]> {
      return this.apollo
        .watchQuery({
          query: getAllPromocionesMongoFront,
        })
        .valueChanges.pipe(
          map((result: any) => {
            const currentDate = new Date();
            return result.data.getAllDataWebPublic
              .map((entity: { promociones: any[], categoria: string }) =>
                entity.promociones.map((promotion: any) => ({
                  ...promotion,
                  categoria: entity.categoria,
                }))
              )
              .flat()
              .filter((promotion: any) =>
                promotion.statusPromocion === true &&
                new Date(promotion.fechaExpiracion) >= currentDate
              );
          })
        );
    }

    getAllCategorias(): Observable<any>{
      return this.apollo
        .watchQuery({
          query: getAllCategorias,
        })
        .valueChanges.pipe(
          map((result: any) => {
            return result.data.getAllDataWebPublic.filter((categoria: any) => categoria.promociones.length > 0);
          })
        );
    }

  filtroByCategoria(categoria: string): Observable<any[]> {
    return this.getAllPromociones().pipe(
      map(promotions => promotions.filter((item: any) => item.categoria === categoria))
    );
  }

  filtroByCodSam(codSam: number): Observable<any[]>{
    return this.getAllPromociones().pipe(
      map(promotions => promotions.filter((item: any) => item.codSam === codSam))
    );
  }


  showAll(): Observable<any[]> {
    return this.getAllPromociones();
  }
}
